<template>
  <div
    class="d-flex flex-row align-items-center p-4 mb-5 rounded-right"
    :class="{ 'flat-alert-danger': errorMessage, 'flat-alert-success': !errorMessage }"
  >
    <i class="fa-regular fa-circle-check"></i>
    <i
      class="d-block far mr-3"
      :class="{
        'fa-times-circle flat-alert-icon-danger': errorMessage,
        'fa-check-circle flat-alert-icon-success': !!successEntriesCount,
      }"
    ></i>
    <div class="m-0 p-0 ml-2 h-100 fs-14 d-flex flex-row align-items-center">
      <template v-if="errorMessage">
        <div class="mr-3">
          <p>{{ translate("EXPORT.OUTCOME.ERROR.TITLE") }}</p>
          <p class="font-italic mb-0">{{ errorMessage }}</p>
        </div>
      </template>
      <template v-else>
        <div class="mr-3">
          <p>{{ translate("EXPORT.OUTCOME.SUCCESS.TITLE") }}</p>
          <p class="mb-0">
            {{
              translate("EXPORT.OUTCOME.SUCCESS.DESCRIPTION", {
                amount: successEntriesCount,
              })
            }}
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import useTranslate from "@/core/composables/translate";

const { translate } = useTranslate();

defineProps({
  successEntriesCount: {
    type: [Number, null],
  },
  errorMessage: {
    type: [String, null],
  },
});

defineEmits(["downloadFile", "restartExport"]);
</script>

<style scoped lang="scss">
@import "@/designSystem/style/variables/_colors.scss";

.flat-alert-danger {
  color: #3e0f13;
  border-left: 2px solid $danger;
  background: $danger-light;
}

.flat-alert-icon-danger {
  color: $danger;
}

.flat-alert-success {
  color: $primary;
  background: $primary-light;
  border-left: 2px solid $primary;
}

.flat-alert-icon-success {
  color: $primary;
}
</style>
